// #region imports

// --- 3rd Pary
import { User } from 'oidc-client';

// --- HS Code
import { LanguageModel } from '..';

// #endregion

export class Constants {
  // OIDC
  public static readonly CHECK_SESSION_ENDPOINT = '/connect/checksession';

  // Registration/Activiation
  public static readonly INITIAL_ACTIVATION_KEY = 'initialActivation';
  public static readonly PARTICIPANT_REDIRECT_DESTINATION_KEY = 'participantRedirectDestination';
  public static readonly PARTICIPANT_SELECTED_SURVEY = 'selectedSurvey';

  // General
  public static readonly DEFAULT_ALERT_TIMEOUT: number = 5000;
  public static readonly ONE_SECOND_IN_MILLISECONDS: number = 1000;
  public static readonly ONE_ADDED_TO_SHOW_COMMENTS_QUESTION_PROGRESS: number = 1;
  public static readonly NUMBER_OF_QUESTIONS_PER_INDICATOR_GROUP: number = 15;
  public static readonly NUMBER_OF_INDICATOR_QUESTIONS: number = 75;
  public static readonly NUMBER_OF_EFFECTIVENESS_QUESTIONS: number = 8;
  public static readonly ACTION_NO_ACTION: string = 'NO_ACTION';
  public static readonly MAXIMUM_NUMBER_OF_DISPLAY_NOTIFICATIONS: number = 6;
  public static readonly NUMBER_OF_RESPONDENTS_PER_GROUP: number = 3;
  public static readonly MAXIMUM_NUMBER_OF_RESPONDENT_GROUPS: number = 5;
  public static readonly EXECUTIVE_PACK_THRESHOLD: number = 6;

  public static readonly EDIT_MODE_NONE = 'none';
  public static readonly EDIT_MODE_ADD = 'add';
  public static readonly EDIT_MODE_EDIT = 'edit';

  // UI
  public static readonly FIRST_NAME_MAXIMUM_LENGTH = 100;
  public static readonly LAST_NAME_MAXIMUM_LENGTH = 100;
  public static readonly PASSWORD_MAXIMUM_LENGTH = 100;
  public static readonly PASSWORD_MINIMUM_LENGTH = 8;
  public static readonly EMAIL_ADDRESS_MAXIMUM_LENGTH = 256;
  public static readonly ISBN_NUMBER_MAXIMUM_LENGTH = 100;
  public static readonly SURVEY_NAME_MAXIMUM_LENGTH = 300;
  public static readonly INVITE_RESPONDENTS_PERSONAL_MESSAGE_MAX_LENGTH = 2000;
  public static readonly SURVEY_HEADER_HEIGHT = 70;
  public static readonly SURVEY_SUBHEADER_HEIGHT = 132;
  public static readonly BOOK_URL = 'https://www.amazon.com/Above-Line-Living-Leading-Heart-ebook/dp/B07QQKHXK8/';
  public static readonly HEARTSTYLES_BUSINESS_ACCOUNT_LINK = 'https://heartstyles.com';
  public static readonly PRIVACY_POLICY_LINK = 'https://heartstyles.com/privacy';
  public static readonly TERMS_OF_AGREEMENT_LINK = 'https://heartstyles.com/terms';
  public static readonly THE_HEARTSTYLES_INDICATOR_LINK = 'https://heartstyles.com/the-heartstyles-indicator';
  public static readonly COOKIE_POLICY_KEY = 'hs-cookie-policy';
  public static readonly COOKIE_POLICY_EXPIRY = 365;
  public static readonly GROUP_NAME_MAXIMUM_LENGTH = 50;
  public static readonly DEFAULT_PAGE_SIZE = 20;
  public static readonly MINIMUM_NUMBER_OF_COMPLETED_RESPONDENTS = 3;
  public static readonly MOBILE_MEDIA_QUERY = '(max-width: 960px)';
  public static readonly MAXIMUM_NUMBER_OF_SELF_SURVEYS = 100;

  public static readonly SELECTED_LANGUAGE_LOCAL_STORAGE_KEY: string = 'hs:pe:selectedLanguage';
  public static readonly DEFAULT_LANGUAGE: LanguageModel = {
    id: 1,
    name: 'English',
    nativeName: 'English',
    isoTwoLetterName: 'en',
    isoTwoLetterCode: 'en',
    isoThreeLetterName: 'ENG',
    cultureCode: 'GB',
    isRtl: false
  };
  public static readonly DEFAULT_LOCALE = 'en-GB';

  public static readonly HINDI_LANGUAGE_ISO_TWO_LETTER_CODE = 'hi';
  public static readonly TURKISH_LANGUAGE_ISO_TWO_LETTER_CODE = 'tr';
  public static readonly FRENCH_LANGUAGE_ISO_TWO_LETTER_CODE = 'fr';
  public static readonly POLISH_LANGUAGE_ISO_TWO_LETTER_CODE = 'pl';
  public static readonly CHINESE_LANGUAGE_ISO_TWO_LETTER_CODE = 'zh';

  // Participant Group
  public static readonly GROUP_NAME_PATCH_PATH = 'GROUPNAME';

  // ManageRespondents
  public static readonly VIEW_MODE_MANAGE = 'manage';
  public static readonly VIEW_MODE_ADD = 'add';
  public static readonly VIEW_MODE_GROUP_ADD_EDIT = 'groupaddedit';
  public static readonly VIEW_MODE_INVITE_PREVIOUS = "inviteprevious";
  public static readonly VIEW_MODE_CONFIRM_CANCEL = "confirmcancel";
  public static readonly UNDO_DELETE_COUNTDOWN_MAX_IN_SECONDS = 2;

  // Claims
  public static readonly CLAIMS_IDENTITY_PROVIDER = "idp";
  public static readonly CLAIMS_SURVEY_PARTICIPANT = 'surveyparticipant';
  public static readonly CLAIMS_SURVEY_RESPONDENT = 'surveyrespondent';
  public static readonly CLAIMS_MOBILE_USER = 'mobileuser';
  public static readonly CLAIMS_COMPANY_BENCH = '8B516715-9A44-422C-8D0E-E9802C2DA3E8';
  public static readonly CLAIMS_COMPANY_ID = 'companyid';
  public static readonly CLAIMS_ENRICHED_USER_DETAILS = 'enrichuserdetails';
  public static readonly CLAIMS_NAME_IDENTIFIER_KEY = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';
  public static readonly CLAIMS_PREFERRED_USERNAME = 'preferred_username';
  public static readonly CLAIMS_SELF_REGISTRATION = 'selfregistration';
  public static readonly CLAIMS_IMPERSONATION_SESSION = 'impersonationsession';
  public static readonly CLAIMS_OPEN_PACKS = 'openpacks';

  // EnrichedUserDetails
  public static readonly ENRICHED_USER_DETAILS_OPTION_YUM_GUID = '2a1e595c-da98-479f-9610-c5ebbdd6c447';
  public static readonly ENRICHED_USER_DETAILS_OPTION_ABOVE_STORE_GUID = 'f4fa53ca-d611-450f-bddf-b01c6ca074a8';

  // Journaling
  public static readonly JOURNAL_TOAST_CLICK_EVENT_NAME = 'journaling';
  public static readonly JOURNAL_ENTRY_MAXIMUM_LENGTH = 400;

  // Events
  public static readonly EVENT_UNDO_DELETE = 'undodelete';
  public static readonly EVENT_UNDO_UPDATE = 'undoupdate';
  public static readonly EVENT_NAVIGATE = 'navigate';

  // Feature toggle constants
  public static readonly FEATURE_ON = 'on';
  public static readonly FEATURE_OFF = 'off';

  public static readonly HTTP_CONFLICT = 409;
}
